import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'; 
import { CookiesProvider } from 'react-cookie';
import Swal from "sweetalert2";

import AppStore, { AppContext } from './AppStore';
import LoadingBar from './common/LoadingBar';
import { PublicRoute, PrivateRoute } from "./ProtectRoute";
import ExceptionRoute from './ExceptionRoute'

// Style
import { ThemeProvider, CssBaseline, StyledEngineProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';

// Layouts
import Layout from './pages/Layout/Layout'
import M_Layout from './pages/Layout/M_Layout'

// Auth
import Login from './pages/Auth/Login'
import Logout from './pages/Auth/Logout'

// PC Components
import PCMain from './pages/Component/PC/PCMain'
import Code from './pages/Component/PC/system/Code'
import KPI from './pages/Component/PC/system/KPI'
import CompanySetting from './pages/Component/PC/system/CompanySetting'
import Menu from './pages/Component/PC/system/Menu'
import Authority from './pages/Component/PC/system/Authority'
import User from './pages/Component/PC/gijun/User'
import Partner from './pages/Component/PC/gijun/Partner'
import Item from './pages/Component/PC/gijun/Item'
import Warehouse from './pages/Component/PC/gijun/Warehouse'
import Workplace from './pages/Component/PC/gijun/Workplace'
import Dept from './pages/Component/PC/gijun/Dept'
import Bom from './pages/Component/PC/gijun/Bom'
import Process from './pages/Component/PC/gijun/Process'
import Resource from './pages/Component/PC/gijun/Resource'
import Order from './pages/Component/PC/order/Order'
import Outgoing from './pages/Component/PC/order/Outgoing'
import OrderStatistics from './pages/Component/PC/order/OrderStatistics'
import OutgoingStatistics from './pages/Component/PC/order/OutgoingStatistics'
import Purchase from './pages/Component/PC/purchase/Purchase'
import Incoming from './pages/Component/PC/purchase/Incoming'
import PurchaseStatistics from './pages/Component/PC/purchase/PurchaseStatistics'
import IncomingStatistics from './pages/Component/PC/purchase/IncomingStatistics'
import LotInfo from './pages/Component/PC/stock/LotInfo'
import LotTrackingInfo from './pages/Component/PC/stock/LotTrackingInfo'
import StockInfo from './pages/Component/PC/stock/StockInfo'
import WarehouseInfo from './pages/Component/PC/stock/WarehouseInfo'
import ProduceWork from './pages/Component/PC/stock/ProduceWork'
import StockAdjustment from './pages/Component/PC/stock/StockAdjustment'
import Discard from './pages/Component/PC/stock/Discard'
import Loss from './pages/Component/PC/stock/Loss'
import StockStatistics from './pages/Component/PC/stock/StockStatistics'
import LotStatistics from './pages/Component/PC/stock/LotStatistics'
import MachineMonitoring from './pages/Component/PC/machining/MachineMonitoring'
import MachineRuningStatus from './pages/Component/PC/machining/MachineRuningStatus'
import DateMachineRuningStatus from './pages/Component/PC/machining/DateMachineRuningStatus'
import MachineProduceInfo from './pages/Component/PC/machining/MachineProduceInfo'
import MachineProducePerformanceInfo from './pages/Component/PC/machining/MachineProducePerformanceInfo'
import MachineProduceCountPerformanceInfo from './pages/Component/PC/machining/MachineProduceCountPerformanceInfo'
import MachineExamCountPerformanceInfo from './pages/Component/PC/machining/MachineExamCountPerformanceInfo'
import MachineSetting from './pages/Component/PC/machining/MachineSetting'
import MachineProductionStatistics from './pages/Component/PC/machining/MachineProductionStatistics'
import MachineProductionLog from './pages/Component/PC/machining/MachineProductionLog'
import MachineFncAIDetection from './pages/Component/PC/machining/MachineFncAIDetection'
import MachineInspect from './pages/Component/PC/machining/MachineInspect'
import MachineToolUsedStatistics from './pages/Component/PC/machining/MachineToolUsedStatistics'
import MachineNCProduceStatistics from './pages/Component/PC/machining/MachineNCProduceStatistics'
import Quality from './pages/Component/PC/quality/Quality'
import QualityMeasurement from './pages/Component/PC/quality/QualityMeasurement'
import QualityStatistics from './pages/Component/PC/quality/QualityStatistics'
import QualityPrice from './pages/Component/PC/quality/QualityPrice'
import OutsourcingPrice from './pages/Component/PC/quality/OutsourcingPrice'
import ClaimInfo from './pages/Component/PC/quality/ClaimInfo'
import ChatModal from './common/ChatModal';
import ChatRedirect from './ChatRedirect';

// Tablet
import TAB_Main from './pages/Component/Tablet/TabletMain'
import TAB_Order from './pages/Component/Tablet/order/TAB_Order'
import TAB_Outgoing from './pages/Component/Tablet/order/TAB_Outgoing'
import TAB_Purchase from './pages/Component/Tablet/purchase/TAB_Purchase'
import TAB_Incoming from './pages/Component/Tablet/purchase/TAB_Incoming'
import TAB_ProduceWork from './pages/Component/Tablet/stock/TAB_ProduceWork'

// Mobile
import MOB_Main from './pages/Component/Mobile/MOB_Main'
import MOB_Order from './pages/Component/Mobile/order/MOB_Order'
import MOB_OrderDetail from './pages/Component/Mobile/order/MOB_OrderDetail'
import MOB_Outgoing from './pages/Component/Mobile/order/MOB_Outgoing'
import MOB_OutgoingDetail from './pages/Component/Mobile/order/MOB_OutgoingDetail'
import MOB_Purchase from './pages/Component/Mobile/purchase/MOB_Purchase'
import MOB_PurchaseDetail from './pages/Component/Mobile/purchase/MOB_PurchaseDetail'
import MOB_Incoming from './pages/Component/Mobile/purchase/MOB_Incoming'
import MOB_IncomingDetail from './pages/Component/Mobile/purchase/MOB_IncomingDetail'
import MOB_QualityMeasurement from './pages/Component/Mobile/quality/MOB_QualityMeasurement'
import MOB_QualityMeasurementDetail from './pages/Component/Mobile/quality/MOB_QualityMeasurementDetail'
import MOB_Discard from './pages/Component/Mobile/stock/MOB_Discard'
import MOB_DiscardDetail from './pages/Component/Mobile/stock/MOB_DiscardDetail'
import MOB_Loss from './pages/Component/Mobile/stock/MOB_Loss'
import MOB_LossDetail from './pages/Component/Mobile/stock/MOB_LossDetail'
import MOB_StockAdjustment from './pages/Component/Mobile/stock/MOB_StockAdjustment'
import MOB_StockAdjustmentDetail from './pages/Component/Mobile/stock/MOB_StockAdjustmentDetail'
import MOB_ProduceWork from './pages/Component/Mobile/stock/MOB_ProduceWork'
import MOB_ProduceWorkDetail from './pages/Component/Mobile/stock/MOB_ProduceWorkDetail'
import MOB_MachineProduceInfo from './pages/Component/Mobile/machining/MOB_MachineProduceInfo'
import MOB_MachineProducePerformanceInfo from './pages/Component/Mobile/machining/MOB_MachineProducePerformanceInfo'
import MOB_MachineProduceCountPerformanceInfo from './pages/Component/Mobile/machining/MOB_MachineProduceCountPerformanceInfo'
import MOB_MachineInspect from './pages/Component/Mobile/machining/MOB_MachineInspect'


const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        outlined: { '&:hover': { backgroundColor: 'inherit' } },
        text:     { '&:hover': { backgroundColor: 'inherit' } },
      },
    },
  },
});

// 📌 AppContent
function AppContent() {
  const { loading } = useContext(AppContext);
  const ChatPage = () => {
    const navigate = useNavigate();
    const goMain = () => {
      const main = localStorage.getItem("main") || (window.location.pathname.startsWith("/m") ? "/m" : "/p");
      navigate(main);
    };
    return <ChatModal fullScreen showSidebarButton onSidebarClick={goMain} chatModalClose={goMain} />;
  };
  
  return (
    <>
      <Routes>
        {/* Public */}
        <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/:diff_token" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/:company_id/:diff_token" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/Login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/Login/:diff_token" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/Login/:company_id/:diff_token" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/Logout" element={<PrivateRoute><Logout /></PrivateRoute>} />

        {/* Chat */}
        <Route path="/chat" element={<ChatRedirect />} />
        {/* PC */}
        <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route path="/p" element={<PCMain />} />
          <Route path="/p/menu" element={<Menu />} />
          <Route path="/p/company_setting" element={<CompanySetting />} />
          <Route path="/p/code" element={<Code />} />
          <Route path="/p/kpi" element={<KPI />} />
          <Route path="/p/authority" element={<Authority />} />
          <Route path="/p/user" element={<User />} />
          <Route path="/p/partner" element={<Partner />} />
          <Route path="/p/item" element={<Item />} />
          <Route path="/p/workplace" element={<Workplace />} />
          <Route path="/p/warehouse" element={<Warehouse />} />
          <Route path="/p/dept" element={<Dept />} />
          <Route path="/p/bom" element={<Bom />} />
          <Route path="/p/process" element={<Process />} />
          <Route path="/p/resource" element={<Resource />} />
          <Route path="/p/order" element={<Order />} />
          <Route path="/p/order/:order_id" element={<Order />} />
          <Route path="/p/outgoing" element={<Outgoing />} />
          <Route path="/p/outgoing/:outgoing_id" element={<Outgoing />} />
          <Route path="/p/order_statistics" element={<OrderStatistics />} />
          <Route path="/p/outgoing_statistics" element={<OutgoingStatistics />} />
          <Route path="/p/purchase" element={<Purchase />} />
          <Route path="/p/purchase/:purchase_id" element={<Purchase />} />
          <Route path="/p/incoming" element={<Incoming />} />
          <Route path="/p/incoming/:incoming_id" element={<Incoming />} />
          <Route path="/p/purchase_statistics" element={<PurchaseStatistics />} />
          <Route path="/p/incoming_statistics" element={<IncomingStatistics />} />
          <Route path="/p/lot_info" element={<LotInfo />} />
          <Route path="/p/lot_tracking_info" element={<LotTrackingInfo />} />
          <Route path="/p/stock_info" element={<StockInfo />} />
          <Route path="/p/warehouse_info" element={<WarehouseInfo />} />
          <Route path="/p/produce_work" element={<ProduceWork />} />
          <Route path="/p/produce_work/:produce_work_id" element={<ProduceWork />} />
          <Route path="/p/stock_adjustment" element={<StockAdjustment />} />
          <Route path="/p/stock_adjustment/:stock_adjustment_id" element={<StockAdjustment />} />
          <Route path="/p/discard" element={<Discard />} />
          <Route path="/p/discard/:discard_id" element={<Discard />} />
          <Route path="/p/loss" element={<Loss />} />
          <Route path="/p/loss/:loss_id" element={<Loss />} />
          <Route path="/p/stock_statistics" element={<StockStatistics />} />
          <Route path="/p/lot_statistics" element={<LotStatistics />} />
          <Route path="/p/machine_monitoring" element={<MachineMonitoring />} />
          <Route path="/p/machine_runing_status" element={<MachineRuningStatus />} />
          <Route path="/p/date_machine_runing_status" element={<DateMachineRuningStatus />} />
          <Route path="/p/machine_inspect" element={<MachineInspect />} />
          <Route path="/p/machine_setting" element={<MachineSetting />} />
          <Route path="/p/machine_production_statistics" element={<MachineProductionStatistics />} />
          <Route path="/p/machine_production_log" element={<MachineProductionLog />} />
          <Route path="/p/machine_fnc_ai_detection" element={<MachineFncAIDetection />} />
          <Route path="/p/machine_produce_info" element={<MachineProduceInfo />} />
          <Route path="/p/machine_produce_performance_info" element={<MachineProducePerformanceInfo />} />
          <Route path="/p/machine_produce_performance_info/:project_id" element={<MachineProducePerformanceInfo />} />
          <Route path="/p/machine_produce_count_performance_info" element={<MachineProduceCountPerformanceInfo />} />
          <Route path="/p/machine_produce_count_performance_info/:data" element={<MachineProduceCountPerformanceInfo />} />
          <Route path="/p/machine_exam_count_performance_info" element={<MachineExamCountPerformanceInfo />} />
          <Route path="/p/machine_exam_count_performance_info/:data" element={<MachineExamCountPerformanceInfo />} />
          <Route path="/p/machine_tool_used_statistics" element={<MachineToolUsedStatistics />} />
          <Route path="/p/machine_nc_produce_statistics" element={<MachineNCProduceStatistics />} />  
          <Route path="/p/quality" element={<Quality />} />
          <Route path="/p/quality_measurement" element={<QualityMeasurement />} />
          <Route path="/p/quality_measurement/:quality_measurement_id" element={<QualityMeasurement />} />
          <Route path="/p/quality_statistics" element={<QualityStatistics />} />
          <Route path="/p/quality_price" element={<QualityPrice />} />
          <Route path="/p/outsourcing_price" element={<OutsourcingPrice />} />
          <Route path="/p/claim" element={<ClaimInfo />} />
          <Route path="/p/chat" element={<ChatPage />} />

          <Route path="/t" element={<TAB_Main />} />
          <Route path="/t/order" element={<TAB_Order />} /> 
          <Route path="/t/order/:order_id" element={<TAB_Order />} />
          <Route path="/t/purchase" element={<TAB_Purchase />} /> 
          <Route path="/t/purchase/:purchase_id" element={<TAB_Purchase />} />
          <Route path="/t/incoming" element={<TAB_Incoming />} /> 
          <Route path="/t/incoming/:incoming_id" element={<TAB_Incoming />} />
          <Route path="/t/outgoing" element={<TAB_Outgoing />} /> 
          <Route path="/t/outgoing/:outgoing_id" element={<TAB_Outgoing />} />
          <Route path="/t/produce_work" element={<TAB_ProduceWork />} /> 
          <Route path="/t/produce_work/:produce_work_id" element={<TAB_ProduceWork />} />
        </Route>

        {/* Mobile */}
        <Route element={<PrivateRoute><M_Layout /></PrivateRoute>}>
          <Route path="/m" element={<MOB_Main />} />
          <Route path="/m/chat" element={<ChatPage />} />
          <Route path="/m/order" element={<MOB_Order />} />
          <Route path="/m/order_detail/:order_id" element={<MOB_OrderDetail />} />
          <Route path="/m/outgoing" element={<MOB_Outgoing />} />
          <Route path="/m/outgoing_detail/:outgoing_id" element={<MOB_OutgoingDetail />} />
          <Route path="/m/purchase" element={<MOB_Purchase />} />
          <Route path="/m/purchase_detail/:purchase_id" element={<MOB_PurchaseDetail />} />
          <Route path="/m/incoming" element={<MOB_Incoming />} />
          <Route path="/m/incoming_detail/:incoming_id" element={<MOB_IncomingDetail />} />
          <Route path="/m/quality_measurement" element={<MOB_QualityMeasurement />} />
          <Route path="/m/quality_measurement_detail/:quality_measurement_id" element={<MOB_QualityMeasurementDetail />} />

          <Route path="/m/discard" element={<MOB_Discard />} />
          <Route path="/m/discard_detail/:discard_id" element={<MOB_DiscardDetail />} />
          <Route path="/m/loss" element={<MOB_Loss />} />
          <Route path="/m/loss_detail/:loss_id" element={<MOB_LossDetail />} />
          <Route path="/m/stock_adjustment" element={<MOB_StockAdjustment />} />
          <Route path="/m/stock_adjustment_detail/:stock_adjustment_id" element={<MOB_StockAdjustmentDetail />} />
          <Route path="/m/produce_work" element={<MOB_ProduceWork />} />
          <Route path="/m/produce_work_detail/:produce_work_id" element={<MOB_ProduceWorkDetail />} />
          <Route path="/m/machine_produce_info" element={<MOB_MachineProduceInfo />} />
          <Route path="/m/machine_inspect" element={<MOB_MachineInspect />} />
          <Route path="/m/machine_produce_performance_info" element={<MOB_MachineProducePerformanceInfo />} />
          <Route path="/m/machine_produce_performance_info/:project_id" element={<MOB_MachineProducePerformanceInfo />} />
          <Route path="/m/machine_produce_count_performance_info" element={<MOB_MachineProduceCountPerformanceInfo />} />
          <Route path="/m/machine_produce_count_performance_info/:data" element={<MOB_MachineProduceCountPerformanceInfo />} />
          <Route path="/m/machine_exam_count_performance_info" element={<MOB_MachineProduceCountPerformanceInfo />} />
          <Route path="/m/machine_exam_count_performance_info/:data" element={<MOB_MachineProduceCountPerformanceInfo />} />
          
        </Route>

        {/* 예외 */}
        <Route path="*" element={<ExceptionRoute />} />
      </Routes>

      {/* 전역 로딩바 */}
      <LoadingBar show={loading} />
    </>
  );
}

// 📌 root.render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CookiesProvider>
        <AppStore>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </AppStore>
      </CookiesProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);
